export class TypeHospitalization {
    name: string;
    id: number;
    code: string;
}
